export default "__VITE_ASSET__A9o5cGYj__"